import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

export default function useRedirect() {
  const { redirectUrl } = useSelector(store => store.application)
  const history = useHistory()
  useEffect(() => {
    if (redirectUrl) {
      history.push(redirectUrl)
    }
  }, [redirectUrl])
}
